<template>
  <section class="filtres">
    <div class="content">
      <div class="row spaceBetween">
        <h1>{{$t('filter.title')}}</h1>
        <div class="row">
          <div class="space"></div>
          <button class="outline" @click="clearAllFilter(true)">{{$t('button.wipe')}}</button>
          <button @click="sendRequestFilter()">{{$t('button.apply')}}</button>
        </div>
      </div>
    </div>
    <hr />
    <div class="content">
      <div>
        <p class="accentuate">{{$t('dateManagement.date')}}</p>
        <div>
          <input
            type="radio"
            v-model="filter.filterByDate.type"
            :value="1"
            @click=" filter.filterByDate.type =  filter.filterByDate.type == 1 ? 0 :  filter.filterByDate.type"
          />
          <span>{{$t('couponHistory.filtres.today')}}</span>
          <span class="tips">{{moment().format('ll')}}</span>
        </div>
        <div>
          <input
            type="radio"
            v-model="filter.filterByDate.type"
            :value="2"
            @click=" filter.filterByDate.type =  filter.filterByDate.type == 2 ? 0 :  filter.filterByDate.type"
          />
          <span>{{$t('couponHistory.filtres.sevenLastDays')}}</span>
          <span
            class="tips"
          >{{moment().add(-7,"days").format('ll')}} {{$t('dateManagement.to')}} {{moment().format('ll')}}</span>
        </div>
        <div>
          <input
            type="radio"
            v-model="filter.filterByDate.type"
            :value="3"
            @click=" filter.filterByDate.type =  filter.filterByDate.type == 3 ? 0 :  filter.filterByDate.type"
          />
          <span>{{$t('couponHistory.filtres.lastMonth')}}</span>
          <span
            class="tips"
          >1 {{$t('dateManagement.to')}} {{moment().add(0,'months').date(0).format('ll')}}</span>
        </div>
        <div>
          <input
            type="radio"
            v-model="filter.filterByDate.type"
            :value="4"
            @click=" filter.filterByDate.type =  filter.filterByDate.type == 4 ? 0 :  filter.filterByDate.type"
          />
          <span>{{$t('couponHistory.filtres.all')}}</span>
        </div>
        <div>
          <input
            type="radio"
            v-model="filter.filterByDate.type"
            :value="5"
            @click=" filter.filterByDate.type =  filter.filterByDate.type == 5 ? 0 :  filter.filterByDate.type"
          />
          <span>{{$t('couponHistory.filtres.personalized')}}</span>
          <div v-if="filter.filterByDate.type == 5">
            <label>{{$t('createCampaign.beginDate')}}</label>
            <div class="row alignCenter">
              <div class="demiRow">
                <input
                  type="date"
                  class="sInput textCenter"
                  v-model="filter.filterByDate.startDate"
                />
              </div>
            </div>
            <div class="row">
              <label>{{$t('createCampaign.endDate')}}</label>
            </div>
            <div class="row alignCenter">
              <div class="demiRow">
                <input type="date" class="sInput textCenter" v-model="filter.filterByDate.endDate" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="spacer-10"></div>
      <div>
        <p class="accentuate">{{$t('campaigns.discount')}}</p>
        <div v-for="disc in this.discount" :key="disc.id">
          <input type="checkbox" :value="disc.id" v-model="currentDiscountsSelected" />
          <span>[ {{disc["sales-channel-name"]}} ] {{disc["product-name"]}} ( {{getDiscountByDiscountObject(disc)}} )</span>
        </div>
      </div>
      <div class="spacer-10"></div>
      <div>
        <p class="accentuate">{{$t('campaignStatus.status')}}</p>
        <div>
          <input
            type="checkbox"
            v-model="filter.filterByTransactionStatus.confirmed"
            :value="true"
            @click="filter.filterByTransactionStatus.confirmed = !filter.filterByTransactionStatus.confirmed"
          />
          <span>{{$t('couponStatus.confirmed')}}</span>
        </div>
        <div>
          <input
            type="checkbox"
            v-model="filter.filterByTransactionStatus.verified"
            :value="true"
            @click="filter.filterByTransactionStatus.verified = !filter.filterByTransactionStatus.verified"
          />
          <span>{{$t('couponStatus.inProgress')}}</span>
        </div>
        <div>
          <input
            type="checkbox"
            v-model="filter.filterByTransactionStatus.retrieved"
            :value="true"
            @click="filter.filterByTransactionStatus.retrieved = !filter.filterByTransactionStatus.retrieved"
          />
          <span>{{$t('couponStatus.retrieved')}}</span>
        </div>
        <div>
          <input
            type="checkbox"
            v-model="filter.filterByTransactionStatus.notUsed"
            :value="true"
            @click="filter.filterByTransactionStatus.notUsed = !filter.filterByTransactionStatus.notUsed"
          />
          <span>{{$t('couponStatus.notUsed')}}</span>
        </div>
      </div>
      <div class="spacer-10"></div>
    </div>
  </section>
</template>

<script>
import moment from "moment";
import generalMethods from "@/mixins/generalMethods";
import Campaigns from "@/services/Campaigns";
import GroupsOfDiscounts from "@/services/GroupsOfDiscounts";
import Discounts from "@/services/Discounts";
export default {
  mixins: [generalMethods],
  props: ["parOptions", "parCampaignId"],
  data() {
    return {
      currentDiscountsSelected: [],
      filter: {
        filterByDate: {
          type: 0,
          startDate: "",
          endDate: ""
        },
        filterByTransactionStatus: {
          confirmed: false,
          notUsed: false,
          retrieved: false,
          autorized: false,
          verified: false
        }
      },
      campaign: {},
      discount: {},
      groupsOfDiscounts: {},
      globalFilter: {}
    };
  },
  mounted() {
    this.getCampaignInfoById(this.parCampaignId);
    this.getDefaultFilter();
  },
  computed: {},
  methods: {
    getDefaultFilter() {
      //console.log("this.parOptions.filterByDiscount");
      //console.log(this.parOptions.filterByDiscount);
      this.clearAllFilter();
      if (this.parOptions && this.parOptions.filterByDate) {
        //console.log("this.parOptions");
        //console.log(this.parOptions);
        if (this.parOptions.filterByDate) {
          this.filter.filterByDate.startDate = this.parOptions.filterByDate
            .startDate
            ? this.convertIsoFrLocaleToDateAndHour(
                this.parOptions.filterByDate.startDate
              ).date
            : "";
          this.filter.filterByDate.endDate = this.parOptions.filterByDate
            .endDate
            ? this.convertIsoFrLocaleToDateAndHour(
                this.parOptions.filterByDate.endDate
              ).date
            : "";
          this.filter.filterByDate.type = this.parOptions.filterByDate.type;
        }
        this.currentDiscountsSelected = this.parOptions.filterByDiscount;
        this.filter.filterByTransactionStatus = this.parOptions
          .filterByTransactionStatus
          ? this.parOptions.filterByTransactionStatus
          : this.filter.filterByTransactionStatus;
      }
    },
    getCampaignInfoById(id) {
      if (id) {
        Campaigns.getById(id).then(res => {
          if (res.data["number-of-used-coupons"] == null)
            res.data["number-of-used-coupons"] = "0";
          else
            res.data["number-of-used-coupons"] = res.data[
              "number-of-used-coupons"
            ].toLocaleString("fr");

          if (res.data["max-number-of-coupons"] == null)
            res.data["max-number-of-coupons"] = "0";
          else
            res.data["max-number-of-coupons"] = res.data[
              "max-number-of-coupons"
            ].toLocaleString("fr");
          this.campaign = res.data;
          this.getDiscountsByCampaignId(id);
        });
      }
    },
    getDiscountsByCampaignId(campaignId) {
      GroupsOfDiscounts.get(campaignId).then(resGoD => {
        if (resGoD.status == 200) {
          Discounts.getByCampaignId(campaignId).then(resD => {
            this.discountsList = resD.data;
            for (var i = 0; i < resGoD.data.length; i++) {
              resGoD.data[i]["discounts-list"] = resD.data.filter(
                x => x["group-of-discounts-id"] == resGoD.data[i]["id"]
              );
            }
            this.groupsOfDiscounts = resGoD.data;
            this.discount = resD.data;
          });
        }
      });
    },
    getDiscountByDiscountObject(discount) {
      var reduction =
        discount["discount-type"] == 1
          ? " - " +
            (discount["discount-value"] / 100).toFixed(2) +
            " " +
            this.convertCurrencyToSymbol(discount["discount-currency"])
          : " - " + discount["discount-value"] + " " + "%";
      if (discount["discount-value"] == 100 && discount["discount-type"] == 0) {
        return this.$t("discountValue.free");
      } else {
        return reduction;
      }
    },
    sendRequestFilter() {
      if (this.filter.filterByDate.type != 0) {
        var momentObjectStart = moment({ hour: 0, minute: 0 });
        var momentObjectEnd = moment({ hour: 23, minute: 59 });
        switch (this.filter.filterByDate.type) {
          case 1: //today
            this.filter.filterByDate = {
              type: 1,
              startDate: momentObjectStart.locale("fr").format(),
              endDate: momentObjectEnd.locale("fr").format()
            };
            break;
          case 2: //last seven days
            this.filter.filterByDate = {
              type: 2,
              startDate: momentObjectStart
                .add(-7,"days")
                .locale("fr")
                .format(),
              endDate: momentObjectEnd.locale("fr").format()
            };
            break;
          case 3: //last month
            this.filter.filterByDate = {
              type: 3,
              startDate: moment(
                new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1)
              )
                .locale("fr")
                .format(),
              endDate: momentObjectEnd
                .add(0, "months")
                .date(0)
                .locale("fr")
                .format()
            };
            break;
          case 4: //all
            this.filter.filterByDate.type = 4;
            this.filter.filterByDate.startDate = "";
            this.filter.filterByDate.endDate = "";
            break;
          case 5: //personalize
            this.filter.filterByDate.type = 5;
            if (this.filter.filterByDate.startDate)
              this.filter.filterByDate.startDate = moment(
                this.filter.filterByDate.startDate + " " + "00:00"
              )
                .locale("fr")
                .format();
            if (this.filter.filterByDate.endDate)
              this.filter.filterByDate.endDate = moment(
                this.filter.filterByDate.endDate + " " + "23:59"
              )
                .locale("fr")
                .format();
            break;
          default:
            this.filter.filterByDate = 0;
        }
      } else {
        this.filter.filterByDate.startDate = "";
        this.filter.filterByDate.endDate = "";
      }
      //console.log("this filter");
      //console.log(this.filter);
      //console.log(this.currentDiscountsSelected);
      this.filter.filterByDiscount = this.currentDiscountsSelected;
      this.globalFilter = {
        string: this.objectToStringFilter(this.filter),
        object: this.filter
      };
      //console.log(this.globalFilter);
      //
      this.$emit("filter", this.globalFilter);
    },
    objectToStringFilter(filter) {
      var appendFilterString = "";
      if (filter.filterByDate.startDate)
        appendFilterString += "&startDate=" + filter.filterByDate.startDate;
      if (filter.filterByDate.endDate)
        appendFilterString += "&endDate=" + filter.filterByDate.endDate;
      //console.log(filter.filterByTransactionStatus);
      if (filter.filterByTransactionStatus.confirmed)
        appendFilterString += "&confirmed=true";
      if (filter.filterByTransactionStatus.retrieved)
        appendFilterString += "&retrieved=true";
      if (filter.filterByTransactionStatus.verified)
        appendFilterString += "&authorized=true";
      if (filter.filterByTransactionStatus.notUsed)
        appendFilterString += "&unauthorized=true";
      if (filter.filterByDiscount.length > 0) {
        filter.filterByDiscount.forEach(idDisc => {
          appendFilterString += "&idDiscounts=" + idDisc;
        });
      }
      return appendFilterString;
    },
    clearAllFilter(force) {
      this.filter = {
        filterByDate: {
          type: 0,
          startDate: "",
          endDate: ""
        },
        filterByDiscount: [],
        filterByTransactionStatus: {
          confirmed: false,
          notUsed: false,
          retrieved: false,
          autorized: false,
          verified: false
        }
      };
      if (force) this.$emit("clear");
    }
  }
};
</script>

<style scoped>
.multiSelect {
  position: absolute;
  top: 45px;
  background-color: white;
  width: 218px;
  border: solid 1px lightgrey;
}
.checkbox {
  font-weight: 400;
  font-size: 1em;
  width: 100%;
  margin: 0;
  padding-left: 10px;
}
.checkbox:hover {
  background-color: #f1f1f1;
}
</style>